import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/lib/i18n";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const { t, lang, setLang } = useI18n();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) navigate("/");
    else toast.error(r.error || "Login failed");
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-white">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-slate-900 text-white">
        <div>
          <div className="label-eyebrow text-slate-400">Real Estate SaaS</div>
          <div className="font-heading text-4xl font-semibold tracking-tight mt-2">KiraTakip</div>
        </div>
        <div>
          <div className="font-heading text-3xl sm:text-4xl font-semibold leading-tight max-w-md">
            {lang === "tr"
              ? "Kiralarınızı tek panelde. Ödemeler, giderler ve raporlar."
              : "Your rentals on one dashboard. Payments, expenses, reports."}
          </div>
          <div className="mt-6 text-slate-400 text-sm max-w-md leading-relaxed">
            {lang === "tr"
              ? "Kiracılarınızı ekleyin, aylık ödemeleri işleyin, giderleri kategoriye göre takip edin. Yılın sonunda net kâr-zarar."
              : "Add tenants, log monthly payments, track expenses. Get a clean P&L at year end."}
          </div>
        </div>
        <div className="text-xs text-slate-500">© KiraTakip</div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="login-form">
          <div className="flex items-center justify-between">
            <div>
              <div className="label-eyebrow">{t("login")}</div>
              <div className="font-heading text-3xl font-semibold text-slate-900 mt-1">{t("welcome")}</div>
            </div>
            <button
              type="button"
              onClick={() => setLang(lang === "tr" ? "en" : "tr")}
              data-testid="lang-toggle-login"
              className="text-xs uppercase tracking-widest font-bold text-slate-500 hover:text-slate-900"
            >
              {lang === "tr" ? "EN" : "TR"}
            </button>
          </div>
          <div className="space-y-3">
            <div>
              <label className="label-eyebrow">{t("email")}</label>
              <Input data-testid="login-email" type="email" required value={email}
                     onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
            </div>
            <div>
              <label className="label-eyebrow">{t("password")}</label>
              <Input data-testid="login-password" type="password" required value={password}
                     onChange={(e) => setPassword(e.target.value)} className="mt-1.5" />
            </div>
          </div>
          <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full h-11 rounded-md bg-slate-900 hover:bg-slate-800">
            {busy ? "…" : t("login")}
          </Button>
          <div className="text-sm text-slate-600">
            {t("no_account")}{" "}
            <Link to="/register" data-testid="go-register" className="font-semibold text-slate-900 underline">
              {t("register")}
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
